import React from 'react';

import autoBind from 'react-autobind';
import request from 'superagent';
import Config from "../Config.jsx";

// import other components within the same project here

class API extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);


    // a testing sample of getting all hotspots of a LOCALE (6748)

    // var requestObj = {
    //   table: "hotspot",
    //   filter: {epack_id:6748},
    //   order_by: "hotspot.id",
    // };
    //
    // requestObj = {
    //   table: "kla",
    //   filter: {},
    // };
    //
    // this.request("get_list", requestObj, this.testAPIOK, this.testAPIFail);


  }

  render() {
      return (
        <div>

        </div>
      )
  }

  testAPIOK(res){
    // the whole return JSON object is at res.body
    console.log(res.body.result);
  }

  testAPIFail(res){
  }

  request(cmd, reqObj=null, callbackOK=null, callbackFail=null){
    var str = "";
    if (reqObj) {
      str = JSON.stringify(reqObj);
    }
    console.log(cmd);
    console.log(reqObj);
    request
      .post(Config.API_PATH())
      .send({ cmd: cmd,
              json: str})
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .end( (err, res) => {
          // Calling the end function will send the request\
        if (err || res.body.result< 0) {
          //  alert('Oh no! error');
          if (callbackFail) {
            callbackFail(err);
          }
        } else {
          if (callbackOK) {
            callbackOK(res);
          }
        }
      });
  }

  request_get(url, callbackOK=null, callbackFail=null){
    request
      .get(url)
      .send()
      .end((err, res) => {
        if(err){
          if(callbackFail){
            callbackFail(err);
          }
        }else{
          if(callbackOK){
            callbackOK(res);
          }
        }
      });
  }
}

export default API;
